// extracted by mini-css-extract-plugin
export var topLink = "topLink-module--topLink--6uhWl";
export var topLinkPadded = "topLink-module--topLinkPadded--iXm3k topLink-module--topLink--6uhWl";
export var back = "topLink-module--back--rv8vs";
export var text = "topLink-module--text--JZU-p";
export var arrow = "topLink-module--arrow--nkNCZ";
export var slideUp = "topLink-module--slideUp--F3Q-D";
export var slideUpLarge = "topLink-module--slideUpLarge--Odatr";